import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map } from 'immutable';
import styles from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
};

function FullAddress({ address }) {
  return (
    <div className={styles.fullAddress}>
      {address.map((a) => (
        <div>{a}</div>
      ))}
    </div>
  );
}

FullAddress.propTypes = {
  address: PropTypes.object,
};

function GoogleLocation({ event, style }) {
  if (!event.get('venue')) {
    return null;
  }
  const location = event.getIn(['venue', 'location']);
  return (
    <div style={{ display: 'flex', marginRight: 10 }}>
      <div className={cn('location', styles.center)} style={style}>
        {location}
      </div>{' '}
    </div>
  );
}

GoogleLocation.propTypes = propTypes;

export default GoogleLocation;
